export class AnexoCadastro {
  descricao: string;
  arquivo: string;
  selectedFile: File;
  idContato?: number;
  idDocumento: number;
  contrato: boolean;
}
